import React, { useEffect, useState } from 'react'

import { sizes } from '~/assets/styles/variables'

import Button from '~/components/atoms/Button'
import Tag from '~/components/atoms/Tag'

import { ContractBoletoCopyInterface } from '~/models/interfaces/services/Contracts'

import { usePluralization } from '~/utils/usePluralization'
import { useUniqueId } from '~/utils/useUniqueId'

import ContractCard from '../ContractCard'

import {
  ContractDataContainer,
  InstallmentListContainer,
  SelectAllButtonRow,
} from './FormModalDialogInstallmentsFields.styles'

import InstallmentListItem from './InstallmentListItem'

const { size0 } = sizes

const validationSchema = null

interface FormModalDialogInstallmentsFieldsInterface {
  formData: any
}

const FormModalDialogInstallmentsFields = ({
  formData,
}: FormModalDialogInstallmentsFieldsInterface) => {
  const { pluralize } = usePluralization()
  const { generateUniqueStringId } = useUniqueId()

  const [contract,
    setContract] = useState<ContractBoletoCopyInterface>(formData.values)

  const [amountSelectableInstallments,
    setAmountSelectableInstallments] = useState<number>(0)

  const [amountSelectedInstallments,
    setAmountSelectedInstallments] = useState<number>(0)

  const [allInstallmentsAreSelected,
    setAllInstallmentsAreSelected] = useState<boolean>(false)

  useEffect(() => {
    setAmountSelectedInstallments(contract.installments.filter((i) => i.selected).length)
    setAmountSelectableInstallments(contract.installments.filter((i) => i.selectable).length)
  }, [contract])

  useEffect(() => {
    setAllInstallmentsAreSelected(
      amountSelectableInstallments === amountSelectedInstallments,
    )
  }, [amountSelectableInstallments, amountSelectedInstallments])

  const handleToggleSelectAll = (): void => {
    if (contract) {
      const stateContract = { ...contract }

      stateContract.installments.forEach((installment) => {
        installment.selected = !allInstallmentsAreSelected && installment.selectable
        return installment
      })

      setContract(stateContract)
    }

    (document.activeElement as any).blur()
  }

  const handleChangeCheckbox = (
    event: React.ChangeEvent<HTMLInputElement>, id: string,
  ) => {
    const { checked } = event.target
    if (contract) {
      contract.installments.forEach((installment) => {
        if (installment.externalCode === id) {
          installment.selected = checked
        }
      })

      setContract({ ...contract })
    }
  }

  return (
    <>
      {contract && (
        <>
          <ContractDataContainer>
            <ContractCard contract={contract} marginBottom={size0} />
          </ContractDataContainer>
          <SelectAllButtonRow>
            <Tag small tagType={amountSelectedInstallments ? 'recommended' : 'disabled'}>
              {
                `${amountSelectedInstallments} ${pluralize(amountSelectedInstallments, ' item selecionado', ' itens selecionados')}`
              }
            </Tag>
            <Button
              disabled={!amountSelectableInstallments}
              onClick={handleToggleSelectAll}
              size="small"
              type="button"
            >
              {allInstallmentsAreSelected ? 'Limpar tudo' : 'Selecionar tudo'}
            </Button>
          </SelectAllButtonRow>

          <InstallmentListContainer>
            {contract.installments.map((installment) => (
              <InstallmentListItem
                handleCheck={handleChangeCheckbox}
                installment={installment}
                key={generateUniqueStringId()}
              />
            ))}
          </InstallmentListContainer>
        </>
      )}
    </>
  )
}

export { FormModalDialogInstallmentsFields, validationSchema }
